import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import imgFallback from 'src/utils/image';

function ElementImageIcon({ icon, height = 25 }) {
  return (
    <GatsbyImage
      alt={icon?.alt ?? ''}
      style={{ height }}
      imgStyle={{ objectFit: 'contain' }}
      image={icon?.image?.asset?.gatsbyImageData ?? imgFallback}
    />
  );
}

export { ElementImageIcon };
